import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App.jsx";
import { LibraryEnvProvider } from "./LibraryEnvContext.jsx";
import { AuthProvider } from "./AuthContext.jsx";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <LibraryEnvProvider>
          <App />
        </LibraryEnvProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
